import {
    ajax,
    ajaxBack
} from '@/utils/request'


// 获取代驾劵列表
export function drivingList() {
    return ajaxBack({
        url: 'api/v1/shop/driveService/h5/list',
        method: "get"
    })
}
// 获取代驾劵详情
export function drivingInfo(id) {
    return ajax(`api/v1/shop/driveService/h5/detail/${id}`)
}
// 获取车主用品列表
export function goodList(params) {
    return ajaxBack({
        url: 'api/v1/h5/goods/page',
        method: "get",
        params: params
    })
}
// 获取热门搜索列表
export function hotList(params) {
    return ajax('api/v1/sysConf/h5/hotOptions', params)
}
// 获取商品详情
export function goodInfo(id) {
    return ajax(`api/v1/h5/goods/${id}`)
}